import { render, staticRenderFns } from "./MedicationAdministrationDetail.vue?vue&type=template&id=2b61681b&scoped=true"
import script from "./MedicationAdministrationDetail.vue?vue&type=script&lang=js"
export * from "./MedicationAdministrationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b61681b",
  null
  
)

export default component.exports